<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('page')"></TitlePage>

    <v-layout wrap>

      <v-flex md10>

        <v-flex md12 class="pl-4 pr-4">
          <v-text-field :label="$t('name')" v-model="item.name" :rules="validation.textRules" :error-messages="errors.name"></v-text-field>
        </v-flex>
        <v-flex md12 class="pl-4 pr-4">
          <v-text-field :label="$t('meta_title')" v-model="item.meta_title" @change="makeSlug" @input="makeSlug"></v-text-field>
        </v-flex>
        <v-flex md12 class="pl-4 pr-4">
          <v-text-field :label="$t('meta_description')" v-model="item.meta_description"></v-text-field>
        </v-flex>
        <v-flex md12 class="pl-4 pr-4">
          <v-text-field :label="$t('slug')" v-model="item.slug" :rules="validation.textRules" :error-messages="errors.slug"></v-text-field>
        </v-flex>

      </v-flex>

      <v-flex md2>

        <v-flex md12 class="pl-4 pr-4 pb-4">
          <v-text-field v-model="item.position" type="number" :label="$t('position')" step="1" min="0" max="100"></v-text-field>
        </v-flex>

        <v-flex md12 class="pl-4 pr-4 pb-4">
          <v-switch v-model="item.status" inset :label="$t('status')" dense hide-details></v-switch>
        </v-flex>

        <v-flex md12 class="pl-4 pr-4 pb-4">
          <v-switch v-model="item.menu_header" inset :label="$t('menu_header')" dense hide-details></v-switch>
        </v-flex>

        <v-flex md12 class="pl-4 pr-4 pb-4">
          <v-switch v-model="item.menu_footer" inset :label="$t('menu_footer')" dense hide-details></v-switch>
        </v-flex>

      </v-flex>

      <v-flex md12 class="pl-4 pr-4">
        <label class="v-label">{{$t('content')}}</label>
        <CKEditor v-if="this.item.content != null" :content="item.content" @message="(data) => item.content = data"></CKEditor>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import CKEditor from "@/components/admin/CKEditor";
import {mapGetters, mapMutations, mapActions} from 'vuex';
const slugify = require('slugify')

export default {
  name: "EditPage",
  components: {CKEditor, TitlePage},
  data() {
    return {
      item: {
        name: '',
        slug: '',
        meta_title: '',
        meta_description: '',
        content: null,
        status: false,
        menu_header: false,
        menu_footer: false,
        position: 0
      },
      check: true,
      errors:{
        name: '',
        slug: '',
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ]
      }
    };
  },
  async created(){
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)

    this.item.name = fetchItem.result.name;
    this.item.slug = fetchItem.result.slug;
    this.item.meta_title = fetchItem.result.meta_title;
    this.item.meta_description = fetchItem.result.meta_description;
    this.item.content = fetchItem.result.content;
    this.item.status = fetchItem.result.status;
    this.item.menu_header = fetchItem.result.menu_header;
    this.item.menu_footer = fetchItem.result.menu_footer;
    this.item.position = fetchItem.result.position;

    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'pages/edit',
      'updateItem':'pages/update',
    }),
    async makeSlug(){
      this.item.slug = slugify(this.item.meta_title, {remove: /[*+~.()'"!:@,/]/g,lower: true, locale: 'it'})
    },
    async update(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.item.name){
        this.check = false
        this.errors.name = this.$t('fillMandatory');
      }

      if(!this.item.slug){
        this.check = false
        this.errors.slug = this.$t('fillMandatory');
      }

    },

    async resetError(){
      this.errors = {
        name: '',
        slug: ''
      }
    }

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>